import { createAttachmentPermissionLevelsFromSharingInfo } from 'owa-attachment-permission';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function getSupportedPermissionLevels(
    response: GetSharingInfoResponse
): AttachmentPermissionLevel[] {
    const permissions = createAttachmentPermissionLevelsFromSharingInfo(response) || [];

    if (permissions.indexOf(AttachmentPermissionLevel.None) === -1) {
        permissions.push(AttachmentPermissionLevel.None);
    }

    return permissions;
}
